import { render } from "./UndoToast.vue?vue&type=template&id=09afe815&ts=true"
import script from "./UndoToast.vue?vue&type=script&lang=ts"
export * from "./UndoToast.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__